import axios from "axios"

const SIGNUP_URL =
  "https://script.google.com/macros/s/AKfycbw7JhJpQsRhkBmfqoPTKIIpeo2UbvrMdSG0P6zUZ3bFXKhqwC7FMIWU/exec"

export const subscribe = email => {
  return axios.post(
    SIGNUP_URL,
    { email: email, secret: "8a5240cc7a86432dad29ffcd801f7542" },
    {
      headers: {
        "Content-Type": "text/plain;charset=utf-8",
      },
    }
  )
}
